"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CalendarTabs = void 0;
var _react = _interopRequireWildcard(require("react"));
var _paulCorePackage = require("paul-core-package");
var _reactRedux = require("react-redux");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constants = require("../../utils/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const {
  getEndDay,
  getFromDay,
  getFrom7Day,
  getFromMonth,
  getFromMax,
  getFromStartYear
} = _paulCorePackage.functions;

/** @todo change numeric translation keys */
/** @todo remove className */
const CalendarTabs = _ref => {
  let {
    dateType = _constants.constDateType.day,
    setParams
  } = _ref;
  const tI = (0, _reactRedux.useSelector)(_paulCorePackage.selectors.getActiveTranslationsInterfaceUILocalizations);
  const updateDate = (0, _react.useCallback)(newDateType => {
    const params = {
      [_constants.calendarParams.dateType]: newDateType
    };
    const endOfDay = getEndDay();
    const fillParameters = _ref2 => {
      let {
        from,
        rangeType = _constants.rangeTypeKey.hour
      } = _ref2;
      params[_constants.calendarParams.rangeType] = rangeType;
      params[_constants.calendarParams.to] = endOfDay;
      params[_constants.calendarParams.from] = from;
    };
    switch (newDateType) {
      case _constants.constDateType.hour:
        {
          fillParameters({
            from: getFromDay(endOfDay),
            rangeType: _constants.rangeTypeKey.minute_1
          });
          break;
        }
      case _constants.constDateType.day:
        {
          fillParameters({
            from: getFromDay(endOfDay),
            rangeType: _constants.rangeTypeKey.minute_15
          });
          break;
        }
      case _constants.constDateType.week:
        {
          fillParameters({
            from: getFrom7Day(endOfDay),
            rangeType: _constants.rangeTypeKey.hour
          });
          break;
        }
      case _constants.constDateType.month:
        {
          fillParameters({
            from: getFromMonth(endOfDay),
            rangeType: _constants.rangeTypeKey.hour
          });
          break;
        }
      case _constants.constDateType.year:
        {
          fillParameters({
            from: getFromStartYear(endOfDay),
            rangeType: _constants.rangeTypeKey.day
          });
          break;
        }
      case _constants.constDateType.max:
        {
          fillParameters({
            from: getFromMax(endOfDay),
            rangeType: _constants.rangeTypeKey.day
          });
          break;
        }
      default:
        break;
    }
    setParams(params);
  }, [setParams]);
  const timePeriodData = [{
    value: _constants.constDateType.hour,
    label: tI[63] /* hours */
  }, {
    value: _constants.constDateType.day,
    label: tI[73] /* Day */
  }, {
    value: _constants.constDateType.week,
    label: tI[61] /* Week */
  }, {
    value: _constants.constDateType.month,
    label: tI[60] /* Month */
  }, {
    value: _constants.constDateType.year,
    label: tI[59] /* Year */
  }];

  return /*#__PURE__*/_react.default.createElement(_paulCorePackage.Tabs, {
    variant: "scrollable",
    scrollButtons: "auto",
    value: dateType,
    onChange: (_, value) => {
      updateDate(value);
    },
    className: "tabs detail_card mb-3"
  }, timePeriodData.map(tab => /*#__PURE__*/_react.default.createElement(_paulCorePackage.Tab, {
    key: tab.value,
    value: tab.value,
    label: tab.label || '',
    className: "tab text-capitalize"
  })));
};
exports.CalendarTabs = CalendarTabs;
CalendarTabs.propTypes = {
  dateType: _propTypes.default.oneOf(Object.values(_constants.constDateType)),
  setParams: _propTypes.default.func
};